( ( $ ) => {
	// lets extract data on reviews if they exists, then render necessary changes to dom.
	const reviewsEl = document.getElementById( 'shopify-product-reviews' );
	if ( !reviewsEl ) {
		return
	}
	const jsonEl = reviewsEl.querySelector( 'script[type="application/ld+json"]' );
	if ( jsonEl instanceof HTMLElement ) {
		try {
			const reviews_data = JSON.parse( jsonEl.innerText.trim() );
			if ( reviews_data && reviews_data.reviewCount ) {
				const reviewCount = parseInt( reviews_data.reviewCount, 10 );
				if ( reviewCount ) {
					const reviews_labeled = reviewCount !== 1 ? 'Reviews' : 'Review';
					// lets render badges enhancements.
					const badge_content = `<span class="reviews-rating_average">${ reviews_data.ratingValue }</span><span class="reviews-rating_average-label">Star Rating</span><a href="#shopify-product-reviews" class="reviews-rating_link">${ reviewCount } ${ reviews_labeled }</a>`;

					$( '[data-shopify-product-reviews-link]' ).html( badge_content );
				}
			}
		} catch ( e ) {
			console.warn( 'error parsing reviews data for product' );
		}

	}

	const $mobileHeader = jQuery( '#mobile-masthead' );
	const $desktopHeader = jQuery( '#masthead' );
	$( 'a[href="#shopify-product-reviews"]' ).on( 'click', function ( event ) {

		event.preventDefault();
		event.stopPropagation();

		const headerHeight = $mobileHeader.is( ':visible' ) ? $mobileHeader.height() : $desktopHeader.height();

		const el = document.getElementById( 'shopify-product-reviews' );
		if ( el instanceof HTMLElement ) {
			$( [ document.documentElement, document.body ] ).animate( {
				scrollTop: $( el ).offset().top - headerHeight
			}, 2000 );
		}
	} )

} )( jQuery )